import React from 'react'
import { Box, Flex, Grid, Text } from '@chakra-ui/core'
import { RankingCardSkeleton } from './RankingCardSkeleton'
import LocaleText from 'components/LocaleText'
import colors from 'constants/colors'
import { PAGE_TITLE_HEIGHT } from 'components/PageTitle'

export const RankingsListSkeleton: React.FC = () => {
  return (
    <Flex
      flexDirection="column"
      w="100%"
      px={['12px', '20px', '24px']}
      py={['12px', '12px', '16px']}
      flexGrow={1}
      height={`calc(100vh - ${PAGE_TITLE_HEIGHT}px)`}
      overflowY="auto"
      overflowX="hidden"
      onScroll={(e) => {
        e.preventDefault()
      }}
    >
      <Flex flexDirection="column" w="100%">
        {/* Competition Section Skeleton */}
        <Box mb={['30px', '30px', '40px']}>
          <Text fontSize={['12px', '14px', '16px']} color={colors.greyMain} mb="20px">
            <LocaleText text="ranking_competition" />
          </Text>
          <Grid
            templateColumns={[
              'repeat(auto-fit, minmax(280px, 1fr))',
              'repeat(auto-fit, minmax(320px, 1fr))',
              'repeat(auto-fit, minmax(350px, 1fr))',
            ]}
            gap={['16px', '32px', '40px']}
            w="100%"
          >
            {[1, 2, 3, 4].map((i) => (
              <RankingCardSkeleton key={`competition-${i}`} />
            ))}
          </Grid>
        </Box>

        {/* Dynamic Section Skeleton */}
        <Box>
          <Text fontSize={['12px', '14px', '16px']} color={colors.greyMain} mb="20px">
            <LocaleText text="ranking_dynamic" />
          </Text>
          <Grid
            templateColumns={[
              'repeat(auto-fit, minmax(280px, 1fr))',
              'repeat(auto-fit, minmax(320px, 1fr))',
              'repeat(auto-fit, minmax(350px, 1fr))',
            ]}
            gap={['16px', '32px', '40px']}
            w="100%"
          >
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <RankingCardSkeleton key={`dynamic-${i}`} />
            ))}
          </Grid>
        </Box>
      </Flex>
    </Flex>
  )
}
